import { Dentist, Sex, SexEnum } from "@jasper/client-models";

export const getGenderLabel = (sex: Sex) => {
  switch (sex) {
    case SexEnum.male:
      return "Homme";
    case SexEnum.female:
      return "Femme";
    default:
      return null;
  }
};

export const getAge = (birthDate: Date) => {
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
};

export const getDentistName = (dentist: Dentist) =>
  ["Dr.", dentist.firstName, dentist.lastName].filter(Boolean).join(" ");
